import axios from "axios";

export default axios.create({
  baseURL: "https://spotify-backend-cohort13.herokuapp.com/"
});



// WEBPACK FOOTER //
// ./src/apiConfig/API.js